




import { FilterList, Instagram } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import axios from "axios";
import Papa from "papaparse";
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "./Navbar";
import ManagerHeader from "./ManagerHeader";
const TableComponent = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);
  const [influencers, setInfluencers] = useState([]);
  const [selectedInfluencers, setSelectedInfluencers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [visibleCount, setVisibleCount] = useState(5);
  const [hasMore, setHasMore] = useState(false);
  // Main drawer filters
  const [gender, setGender] = useState("");
  const [minAge, setMinAge] = useState("");
  const [maxAge, setMaxAge] = useState("");
  const [minUsersCount, setMinUsersCount] = useState("");
  const [maxUsersCount, setMaxUsersCount] = useState("");
  const [location, setLocation] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  // Instant filter dropdown states
  const [dropdownGender, setDropdownGender] = useState("");
  const [dropdownCity, setDropdownCity] = useState("");
  const [dropdownCategory, setDropdownCategory] = useState("");

  const [cityOptions, setCityOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [genderOptions, setGenderOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [dropdownCountry, setDropdownCountry] = useState("");
  const navigate = useNavigate();





    const fetchInfluencers = async () => {
    setLoading(true);
    setError(null);
    try {
      const managerId = localStorage.getItem("managerID");
      console.log("manager  amanneger searhc",managerId)
      const response = await axios.post(
        `https://server-side-influencer.onrender.com/manager/search/${managerId}`,
        {
          searchTerm: debouncedQuery,
          page: 1,
          perPage: 100,
          sort: "-score",
          socialTypes: "INST,FB",
          gender,
          minAge,
          maxAge,
          minUsersCount,
          maxUsersCount,
          location,
          city,
          country,
        }
      );

      const data = response?.data?.data || [];
      setInfluencers(data);
      // set dropdown options
      setCityOptions([...new Set(data.map(i => i.city).filter(Boolean))]);
      setCategoryOptions([...new Set(data.flatMap(i => i.categories || []))]);
      setGenderOptions([...new Set(data.map(i => i.gender).filter(Boolean))]);
      setCountryOptions([...new Set(data.map(i => i.country).filter(Boolean))]);
      toast.success("Response: " + response.data.message);
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to fetch data");
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  // Search and filter logic
  const filteredInfluencers = influencers.filter((inf) => {
    return (
      (!dropdownGender || inf.gender === dropdownGender) &&
      (!dropdownCity || inf.city === dropdownCity) &&
      (!dropdownCategory || (inf.categories || []).includes(dropdownCategory)) &&
      (!dropdownCountry || inf.country === dropdownCountry)
    );
  });

  const handleLoadMore = () => {
    setVisibleCount(prev => prev + 5);
  };
  const handleCheckboxChange = (influencer) => {
    setSelectedInfluencers((prev) => {
      const exists = prev.find((i) => i.cid === influencer.cid);
      if (exists) {
        return prev.filter((i) => i.cid !== influencer.cid);
      } else {
        return [...prev, influencer];
      }
    });
  };

  const handleExportCSV = () => {
    const csvData = selectedInfluencers.map((inf) => ({
      Name: inf.name || "NA",
      "User Name": inf.screenName || "NA",
      "Instagram URL": inf.url || "NA",
      Gender: inf.gender || "NA",
      City: inf.city || "NA",
      Categories: inf.categories?.join(", ") || "NA",
      Country: inf.country || "NA",
      "Avg Views": formatNumber(inf.avgViews) || "NA",
      "Avg ER": inf.avgER || "NA",
      "Avg Interactions": formatNumber(inf.avgInteractions) || "NA",
      "Contact Email": inf.contactEmail || "NA",
    }));

    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "selected_influencers.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleViewMore = (influencer) => {
    navigate("/searchdetails1", {
      state: { influencerData: influencer },
    });
  };

  const formatNumber = (num) => {
    if (num >= 1e6) return (num / 1e6).toFixed(1) + "M";
    if (num >= 1e3) return (num / 1e3).toFixed(1) + "K";
    return num;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 500);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    fetchInfluencers();
  }, [debouncedQuery]);

  const handleApplyFilters = () => {
    fetchInfluencers();
    setIsDrawerOpen(false);
  };

    useEffect(() => {
      const handleResize = () => {
 
        setIsSmallScreen(window.innerWidth <= 780);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

 

  return (
    <div className="flex">
      
            <div className="absolute top-0 left-0 w-full z-40 ml-0">
              <ManagerHeader  page="search " />
            </div>
      <div className="text-white fixed top-0 left-0 bottom-0 z-50">
        <Navbar />
      </div>

      <div className="w-full relative" 
style={{ marginLeft: isSmallScreen ? '0px' : '90px' }} 

>
        <div className="mb-6 text-center ml-10 " style={{

  marginTop: isSmallScreen ? '80px' : '90px'
}}>
          <h2 className="text-3xl font-bold text-gray-800 mb-5">
            Start searching influencers in real-time
          </h2>
          <div className="relative w-1/2 mx-auto">
            <input
              type="text"
              placeholder="Search by name, city, or country..."
              className="w-full px-4 py-2 pl-6 rounded-full border border-gray-300 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 mt-5  mb-5"
              value={searchQuery}
              onChange={handleSearchChange}
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="absolute left-3 top-3 h-5 w-5 text-gray-400"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M9 3a6 6 0 100 12 6 6 0 000-12zM3 9a6 6 0 1112 0 6 6 0 01-12 0z"
                clipRule="evenodd"
              />
            </svg>
          </div>

          {/* NEW FILTERSssss AAas*/}
          <div className="flex flex-wrap justify-center gap-4 mt-7">
            <select
              value={dropdownGender}
              onChange={(e) => setDropdownGender(e.target.value)}
              className="px-2 py-2 border rounded-md shadow-md"
            >
              <option value=""> Genders</option>
              {genderOptions.map((g) => (
                <option key={g} value={g}>
                  {g === "m" ? "Male" : g === "f" ? "Female" : g}
                </option>
              ))}
            </select>

            <select
              value={dropdownCity}
              onChange={(e) => setDropdownCity(e.target.value)}
              className="px-2 py-2 border rounded-md shadow-md"
            >
              <option value="">Cities</option>
              {cityOptions.map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
            </select>

            <select
              value={dropdownCategory}
              onChange={(e) => setDropdownCategory(e.target.value)}
              className="px-2 py-2 border rounded-md shadow-md"
            >
              <option value="">Categories</option>
              {categoryOptions.map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>

            <select
              value={dropdownCountry}
              onChange={(e) => setDropdownCountry(e.target.value)}
              className="px-2 py-2 border rounded-md shadow-md"
            >
              <option value="">Countries</option>
              {countryOptions.map((country) => (
                <option key={country} value={country}>
                  {country}
                </option>
              ))}
            </select>


            <button
          onClick={() => setIsDrawerOpen(!isDrawerOpen)}
          className="text-sm px-4 py-2 mb-2 text-gray-900 border border-gray-400 bg-gray-100 hover:bg-gray-200 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg focus:outline-none dark:bg-gray-600 dark:hover:bg-gray-700 dark:border-gray-500 dark:focus:ring-gray-800 whitespace-nowrap sm:text-base sm:px-5 sm:py-2.5 ml-13"
        >
           <FilterList className="mr-2" />
          All Filters
        </button>
          </div>
        </div>

        {/* <button
          onClick={() => setIsDrawerOpen(!isDrawerOpen)}
          className="text-white ms-10 bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
        >
          Filter
        </button> */}

        {/* Keep drawer as-is */}
        <div
          className={`fixed top-0 right-0 w-96 h-full bg-white shadow-lg p-6 space-y-4 transition-transform duration-300 ease-in-out transform z-50 ${
            isDrawerOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="flex justify-between items-center">
            <h3 className="text-xl font-semibold">Filter Influencers</h3>
            <button onClick={() => setIsDrawerOpen(false)}>X</button>
          </div>

          {/* Inputs */}
          <input
            type="text"
            placeholder="Gender (m/f)"
            value={gender}
            onChange={(e) => setGender(e.target.value)}
            className="w-full p-4 border border-indigo-300 rounded-md shadow-md"
          />
          <input
            type="number"
            placeholder="Min Age"
            value={minAge}
            onChange={(e) => setMinAge(e.target.value)}
            className="w-full p-4 border border-indigo-300 rounded-md shadow-md"
          />
          <input
            type="number"
            placeholder="Max Age"
            value={maxAge}
            onChange={(e) => setMaxAge(e.target.value)}
            className="w-full p-4 border border-indigo-300 rounded-md shadow-md"
          />
          <input
            type="number"
            placeholder="Min Users Count"
            value={minUsersCount}
            onChange={(e) => setMinUsersCount(e.target.value)}
            className="w-full p-4 border border-indigo-300 rounded-md shadow-md"
          />
          <input
            type="number"
            placeholder="Max Users Count"
            value={maxUsersCount}
            onChange={(e) => setMaxUsersCount(e.target.value)}
            className="w-full p-4 border border-indigo-300 rounded-md shadow-md"
          />
          <input
            type="text"
            placeholder="Location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            className="w-full p-4 border border-indigo-300 rounded-md shadow-md"
          />
          <input
            type="text"
            placeholder="City"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            className="w-full p-4 border border-indigo-300 rounded-md shadow-md"
          />
          <input
            type="text"
            placeholder="Country"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            className="w-full p-4 border border-indigo-300 rounded-md shadow-md"
          />

          <button
            onClick={handleApplyFilters}
            className="w-full bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl text-white py-4 rounded-md font-medium"
          >
            Apply Filters
          </button>
        </div>

        {/* Table */}
        {loading ? (
          <div className="text-center">
            <Skeleton count={5} height={50} />
          </div>
        ) : filteredInfluencers.length === 0 ? (
          <div className="text-center text-gray-500 mt-10">
            No search results available.
          </div>
        ) : (
          <>
          {filteredInfluencers.length > 0 && (
  <div className="text-xl text-black-600 mb-2 ml-12">
    Showing {Math.min(visibleCount, filteredInfluencers.length)} of {filteredInfluencers.length} results
  </div>
)}

            <div className="overflow-x-auto mt-10">
              <table className="min-w-max table-auto border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border p-2">Select</th>
                    <th className="border p-2">Profile Pic</th>
                    <th className="border p-2">Name</th>
                    <th className="border p-2">User Name</th>
                    <th className="border p-2">Instagram URL</th>
                    <th className="border p-2">Gender</th>
                    <th className="border p-2">City</th>
                    <th className="border p-2">Categories</th>
                    <th className="border p-2">Country</th>
                    <th className="border p-2">Avg Views</th>
                    <th className="border p-2">Avg ER</th>
                    <th className="border p-2">Avg Interactions</th>
                    <th className="border p-2">Contact Email</th>
                    <th className="border p-2">Followers</th>
                    <th className="border p-2">Tags</th>
                    <th className="border p-2">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredInfluencers.slice(0, visibleCount).map((item) => (
                    <tr key={item.cid} className="even:bg-gray-50">
                      <td className="border p-2 text-center">
                        <input
                          type="checkbox"
                          checked={selectedInfluencers.some((i) => i.cid === item.cid)}
                          onChange={() => handleCheckboxChange(item)}
                        />
                      </td>
                      <td className="border p-2">
                        <img
                          src={
                            item.image ||
                            "https://res.cloudinary.com/dwy9jfjpq/image/upload/v1739715011/manager_profile_pics/xru8bht53ml5f5rvui9y.jpg"
                          }
                          alt={item.name}
                          className="w-16 h-16 rounded-full"
                        />
                      </td>
                      <td className="border p-2">{item.name || "NA"}</td>
                      <td className="border p-2">{item.screenName || "NA"}</td>
                      <td className="border p-2">
                        {item.url ? (
                          <a href={item.url} target="_blank" rel="noopener noreferrer">
                            <IconButton>
                              <Instagram style={{ color: "#9b4dca" }} />
                            </IconButton>
                          </a>
                        ) : (
                          "NA"
                        )}
                      </td>
                      <td className="border p-2">{item.gender || "NA"}</td>
                      <td className="border p-2">{item.city || "NA"}</td>
                      <td className="border p-2">{item.categories?.join(", ") || "NA"}</td>
                      <td className="border p-2">{item.country || "NA"}</td>
                      <td className="border p-2">{formatNumber(item.avgViews)}</td>
                      <td className="border p-2">{item.avgER || "NA"}</td>
                      <td className="border p-2">{formatNumber(item.avgInteractions)}</td>
                      <td className="border p-2">{item.contactEmail || "NA"}</td>
                      <td className="border p-2">{formatNumber(item.usersCount)}</td>
                      <td className="border p-2">{item.tags?.slice(0, 4).join(", ") || "NA"}</td>
                      <td className="border p-2">
                        <button
                          className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl font-medium rounded-lg text-sm px-5 py-2.5"
                          onClick={() => handleViewMore(item)}
                        >
                          View More
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
{visibleCount < filteredInfluencers.length && (
  <div className="text-center mt-4">
    {!loading ? (
      <button
        onClick={handleLoadMore}
        className="bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 ml-8 text-white transition duration-300"
      >
        Load More
      </button>
    ) : (
      <div style={{ marginTop: '10px', fontSize: '16px', color: '#555' }}>
        Loading...
      </div>
    )}
  </div>
)}

            </div>

            {selectedInfluencers.length > 0 && (
              <div className="text-right mt-4 me-10">
                <button
                  onClick={handleExportCSV}
                  className="bg-gradient-to-br from-purple-600 to-blue-500 text-white py-2 px-6 rounded-lg font-medium"
                >
                  Export Selected to CSV
                </button>
              </div>
            )}
          </>
        )}
      </div>
      <ToastContainer />
    </div>
  );
};

export default TableComponent;
